// file path: src\services\project-task.service.ts

import axios, { Axios, AxiosResponse } from "axios";
import { apiBaseUrl } from "../config";
import { getApiPrefix, getAuthHeader } from "./auth.service";
import Task, { SubTask, TaskAttachment } from "../Types/project-task.type";


export function fetchTasks(projectId: number, role: string = 'super-admin'): Promise<Task[]> {
    return axios.get(apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/tasks`, getAuthHeader())
        .then((res) => {
            const tasks = res.data as any[]
            tasks.forEach((item, index) => {
                item.position = index;
                item.hours_allotted = parseFloat(item.hours_allotted.toString()) || 0;
                item.hours_tracked = parseFloat(item.hours_tracked.toString()) || 0;
                item.sub_tasks.forEach((subTask: any, si: number) => {
                    subTask.position = si;
                    subTask.hours_tracked = parseFloat(subTask.hours_tracked.toString()) || 0;
                });
            });
            return tasks as Task[];
        });
}

export function insertProjectTask(
    project_id: number,
    task_id: number,
    sub_task_id: number,
    dataToSend: Partial<SubTask>,
    role: string
): Promise<any> {
    const url = apiBaseUrl + getApiPrefix(role) + `projects/${project_id}/tasks`;
    return axios.post(url, { ...dataToSend, task_id, sub_task_id }, getAuthHeader());
}
export function updateProjectTask(
    project_id: number,
    task_id: number,
    sub_task_id: number,
    dataToSend: Partial<SubTask>,
    role: string
): Promise<any> {
    const url = apiBaseUrl + getApiPrefix(role) + `projects/${project_id}/tasks/${task_id}`;
    return axios.put(url, { ...dataToSend, sub_task_id }, getAuthHeader());
}

export function archiveTaskService(
    projectId: number,
    task_id: number,
    archived: boolean,
    role: string
): Promise<any> {
    const dataToSend = { archived };
    const url = apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/tasks/${task_id}/archive`;
    return axios.put(url, dataToSend, getAuthHeader());
}

//todo: Need to make an UnArchived All Api
export function unarchiveAllTasksService(
    projectId: number,
    role: string
): Promise<any> {
    const url = `${apiBaseUrl}${getApiPrefix(role)}projects/${projectId}/tasks/unarchive-all`;
    return axios.put(url, {}, getAuthHeader());
}

export function removeMember(projectId: number, user_id: number): Promise<any> {
    return axios.delete(apiBaseUrl + `projects/${projectId}/members/${user_id}`, getAuthHeader());
}

export function addMember(projectId: number, user_id: number): Promise<any> {
    return axios.post(apiBaseUrl + `projects/${projectId}/member`, { user_id }, getAuthHeader());
}

export function updateTaskInBulk(projectId: number, dataToPut: any, role: string): Promise<any> {
    return axios.put(apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/tasks-in-bulk/`, dataToPut, getAuthHeader());
}

export function createTask(values: any): Promise<any> {
    return axios.post(apiBaseUrl + 'projects', values, getAuthHeader());
}

export function deleteTask(projectId: number, taskId: number, role: string): Promise<any> {
    return axios.delete(apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/tasks/${taskId}`, getAuthHeader());
}

export function deleteSubTask(projectId: number, taskId: number, subTaskId: number, role: string = 'super-admin'): Promise<any> {
    return axios.delete(apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/tasks/${taskId}/sub_tasks/${subTaskId}`, getAuthHeader());
}
export function deleteTasks(projectId: number, taskIds: number[], role: string): Promise<any> {
    const url = `${apiBaseUrl}${getApiPrefix(role)}projects/${projectId}/tasks-in-bulk`;
    return axios.delete(url, {
        ...getAuthHeader(),
        data: { task_ids: taskIds }, 
    });
}

export function moveTasksToProject(fromProjectId: number, toProjectId: number, dataToPost: { task_ids: number[]; section: string },role:string): Promise<any> {
    return axios.post(apiBaseUrl + getApiPrefix(role) + `projects/${fromProjectId}/tasks/move/${toProjectId}`,dataToPost, getAuthHeader());
}

export function duplicateTasksToProject(fromProjectId: number, toProjectId: number, dataToPost: { task_ids: number[]; section: string }, role: string): Promise<any> {
    return axios.post(`${apiBaseUrl}${getApiPrefix(role)}projects/${fromProjectId}/tasks/copy/${toProjectId}`, dataToPost,getAuthHeader());
  }
export function getSectionsByProject(ProjectId: number,role: string): Promise<any> {
    return axios.get(apiBaseUrl + getApiPrefix(role) + `projects/${ProjectId}/sections`,getAuthHeader());
}









export class ProjectTaskDocumentService {
    projectId: number;
    taskId: number;
    role: string;
    headers: any;

    constructor(projectId: number, taskId: number, role: string) {
        this.projectId = projectId;
        this.taskId = taskId;
        this.role = role;
        this.headers = getAuthHeader();
    }

    index(): Promise<AxiosResponse<TaskAttachment[]>> {
        return axios.get(apiBaseUrl + getApiPrefix(this.role) + `projects/${this.projectId}/tasks/${this.taskId}/documents`, this.headers);
    }

    store(dataToPost: any): Promise<any> {
        return axios.post(apiBaseUrl + getApiPrefix(this.role) + `projects/${this.projectId}/tasks/${this.taskId}/documents`, dataToPost, this.headers);
    }

    delete(documentId: number): Promise<any> {
        return axios.delete(apiBaseUrl + getApiPrefix(this.role) + `projects/${this.projectId}/tasks/${this.taskId}/documents/${documentId}`, this.headers);
    }
}

export class ProjectTaskCommentService {
    projectId: number;
    taskId: number;
    role: string;
    headers: any;

    constructor(projectId: number, taskId: number, role: string) {
        this.projectId = projectId;
        this.taskId = taskId;
        this.role = role;
        this.headers = getAuthHeader();
    }

    index(): Promise<any> {
        return axios.get(apiBaseUrl + getApiPrefix(this.role) + `projects/${this.projectId}/tasks/${this.taskId}/comments`, this.headers);
    }

    store(dataToPost: any): Promise<any> {
        return axios.post(apiBaseUrl + getApiPrefix(this.role) + `projects/${this.projectId}/tasks/${this.taskId}/comments`, dataToPost, this.headers);
    }

    delete(commentId: number): Promise<any> {
        return axios.delete(apiBaseUrl + getApiPrefix(this.role) + `projects/${this.projectId}/tasks/${this.taskId}/comments/${commentId}`, this.headers);
    }
}
